export default {
  'de-AT': process.env.DOMAIN_DE_AT!,
  'de-CH': process.env.DOMAIN_DE_CH!,
  'de-DE': process.env.DOMAIN_DE_DE!,
  'fi-FI': process.env.DOMAIN_FI_FI!,
  'fr-BE': process.env.DOMAIN_FR_BE!,
  'fr-CH': process.env.DOMAIN_FR_CH!,
  'fr-FR': process.env.DOMAIN_FR_FR!,
  'nl-BE': process.env.DOMAIN_NL_BE!,
  'nl-NL': process.env.DOMAIN_NL_NL!,
}
